import { FormEvent, useCallback, useEffect, useState } from "react"
import {
  ApplyForProgrammeCredentials,
  Form,
  ProgramType,
  useAppNotificationStore,
  useApplicationStore,
  useProfileStore,
} from "stores"
import { Button, H4, Label, P1, SelectInput, SelectOption } from "components"
import { useNavigate } from "react-router-dom"

export const ProgramChoices: React.FC<{}> = () => {
  const { setDashboardContext } = useAppNotificationStore()
  const navigate = useNavigate()
  const { toast } = useAppNotificationStore()
  const [form] = useState(new Form<ApplyForProgrammeCredentials>())
  const [desiredProgram, setDesiredProgram] = useState()
  const { applyForProgramme, getProgrammes, programCategories } =
    useApplicationStore()
  const [programmes, setProgrammes] = useState<ProgramType[]>([])
  useEffect(() => {
    setDashboardContext("Program Choices")
  }, [setDashboardContext])

  const { profile } = useProfileStore()
  const [selectedProgram, setSelectedProgram] = useState<
    ApplyForProgrammeCredentials["programmeId"]
  >(profile?.programmeId)

  const getProgrammList = useCallback(async () => {
    try {
      await getProgrammes().then((e) => {
        const matchedItem = e.find((item: any) =>
          item.programmes.some(
            (programme: any) => programme.id === profile?.programmeId
          )
        )
        if (matchedItem) {
          setDesiredProgram({ ...matchedItem })
          setProgrammes(matchedItem.programmes)
        }
        // console.log("MATCHED ITEM")
        // console.log(matchedItem)
      })
    } catch (error) {
      console.log(error)
      toast.error("Unable to get programmes")
    }
  }, [getProgrammes, toast])

  useEffect(() => {
    getProgrammList()
  }, [getProgrammList])

  const handleHandleApplyForProgramme = async (e: FormEvent) => {
    e.preventDefault()
    form.submitting(true)

    try {
      await applyForProgramme({ programmeId: selectedProgram! }).then(
        (resp) => {
          form.submitting(false)

          if (resp === undefined) return
          if (resp.isSuccessful === true) {
            toast.success(resp.message)
            navigate("/dashboard/registration/records")
          } else {
            toast.error(resp.title)
            form.setErrors(resp.errors)
          }
        }
      )
    } catch (error: any) {
      form.submitting(false)
      console.log(error)
      toast.error(error?.message as string)
    }
  }

  return (
    <div className="flex flex-col gap-12 items-center">
      <div className="flex flex-col items-center gap-6">
        <H4 className="font-semibold text-accentText">Program Choices</H4>
        <P1 className="text-accentGrey1 text-center">
          Select your choice of program
        </P1>
      </div>
      <form
        onSubmit={handleHandleApplyForProgramme}
        className="w-full lg:w-[536px] flex flex-col gap-8"
      >
        <div className="space-y-[5px] w-full">
          <Label aria-required>Your Desired Program</Label>
          <SelectInput
            placeholder="Select program"
            required
            onChange={(e) => {
              setProgrammes(
                programCategories.find((c) => c.name === e.target.value)
                  ?.programmes ?? []
              )
            }}
          >
            {programCategories.map((category, index) => (
              <SelectOption
                key={index}
                value={category.name}
                selected={category.name === (desiredProgram as any)?.name}
              >
                {category.name}
              </SelectOption>
            ))}
          </SelectInput>
        </div>

        <div className="space-y-[5px] w-full">
          <Label aria-required>Program Type</Label>
          <SelectInput
            placeholder="Select program type"
            onChange={(e) => setSelectedProgram(e.currentTarget.value)}
            required
          >
            {programmes.map((program, index) => (
              <SelectOption
                key={index}
                value={program.id}
                selected={program.id === profile?.programmeId}
              >
                {program.description}
              </SelectOption>
            ))}
          </SelectInput>
        </div>

        <div className="flex gap-4 justify-end items-center mt-2">
          <Button
            type="button"
            title="Previous"
            color="secondary"
            className="w-52"
            onClick={() => navigate("/dashboard/registration/next-of-kin")}
          >
            Previous
          </Button>
          <Button
            type="submit"
            title="Next"
            color="primary"
            className="w-52"
            disabled={form.isSubmitting}
            submitting={form.isSubmitting ? "true" : "false"}
          >
            Next
          </Button>
        </div>
      </form>
    </div>
  )
}
